import { render, staticRenderFns } from "./RecordComparison.vue?vue&type=template&id=34b3fafe&"
import script from "./RecordComparison.vue?vue&type=script&lang=js&"
export * from "./RecordComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports